import {
    AircraftData,
    ShipData,
    ShipTypes,
    SuperCapData,
    UnitData,
    UnitDataBase,
    UnitDataGroup,
} from "./ship-data-types";

const CARRIER_DATA: SuperCapData[] = [
    {
        id: "cr1",
        name: "CV3000",
        type: ShipTypes.carrier,
        pop: 40,
        limit: 5,
        modules: {
            m1: { id: "m1", isBase: true, name: "综合舰载机搭载平台", shortName: "综合战机" },
            m2: { id: "m2", isBase: false, name: "综合战机系统", shortName: "综合平台" },
            m3: { id: "m3", isBase: false, name: "大型舰载机平台", shortName: "大型机仓" },
            a1: { id: "a1", isBase: true, name: "龙石火炮系统", shortName: "龙石火炮" },
            a2: { id: "a2", isBase: false, name: "防空导弹平台", shortName: "防空导弹" },
            b1: { id: "b1", isBase: false, name: "导弹防御系统", shortName: "导弹防御" },
            b2: { id: "b2", isBase: false, name: "护航艇搭载平台", shortName: "炮艇平台" },
            b3: { id: "b3", isBase: false, name: "信息无人机支援平台", shortName: "无人机台" },
        },
    },
    {
        id: "cr2",
        name: "太阳鲸",
        type: ShipTypes.carrier,
        pop: 55,
        limit: 5,
        modules: {
            m1: { id: "m1", isBase: true, name: "护航艇坞仓", shortName: "护航艇仓" },
            m2: { id: "m2", isBase: false, name: "大型载机系统", shortName: "大型载机" },
            a1: { id: "a1", isBase: true, name: "综合武器库", shortName: "综合武器" },
            a2: { id: "a2", isBase: false, name: "投射武器平台", shortName: "投射平台" },
            a3: { id: "a3", isBase: false, name: "综合火炮平台", shortName: "综合火炮" },
            b1: { id: "b1", isBase: true, name: "舰载机维护系统", shortName: "载机维护" },
            b2: { id: "b2", isBase: false, name: "护航艇搭载平台", shortName: "炮艇平台" },
            c1: { id: "c1", isBase: false, name: "舰载机平台", shortName: "载机平台" },
            c2: { id: "c2", isBase: false, name: "攻城无人机", shortName: "攻城飞机" },
            c3: { id: "c3", isBase: false, name: "防空导弹平台", shortName: "防空导弹" },
        },
    },
    {
        id: "cr3",
        name: "南十字元帅级",
        type: ShipTypes.carrier,
        pop: 40,
        limit: 5,
        modules: {
            m1: { id: "m1", isBase: true, name: "白色闪光综合武器库", shortName: "综合武器" },
            m2: { id: "m2", isBase: false, name: "白色闪光综合武器库", shortName: "综合武器" },
            a1: { id: "a1", isBase: true, name: "综合舰载机平台", shortName: "载机平台" },
            a2: { id: "a2", isBase: false, name: "护航艇坞仓", shortName: "护航艇仓" },
            b1: { id: "b1", isBase: false, name: "附加舰载机搭载平台", shortName: "载机平台" },
            b2: { id: "b2", isBase: false, name: "导弹防御系统", shortName: "导弹防御" },
            b3: { id: "b3", isBase: false, name: "侦查无人机系统", shortName: "侦查飞机" },
            c1: { id: "c1", isBase: true, name: "附加能源系统", shortName: "能源系统" },
            c2: { id: "c2", isBase: false, name: "火控辅助校准系统", shortName: "火控辅助" },
        },
    },
    {
        id: "cr6",
        name: "永恒苍穹级",
        type: ShipTypes.carrier,
        pop: 40,
        limit: 5,
        modules: {
            m1: { id: "m1", isBase: true, name: "联合作战机库I型", shortName: "机库一型" },
            m2: { id: "m2", isBase: false, name: "联合作战机库I型", shortName: "机库二型" },
            m3: { id: "m3", isBase: false, name: "联合作战机库III型", shortName: "机库三型" },
            a1: { id: "a1", isBase: true, name: "联合火炮系统", shortName: "火炮系统" },
            a2: { id: "a2", isBase: false, name: "实验性粒子炮塔系统", shortName: "离子炮塔" },
            a3: { id: "a3", isBase: false, name: "脉冲防空系统", shortName: "脉冲防空" },
            b1: { id: "b1", isBase: false, name: "反舰投射系统", shortName: "反舰投射" },
            b2: { id: "b2", isBase: false, name: "防御拦截系统", shortName: "防御拦截" },
            b3: { id: "b3", isBase: false, name: "防空导弹平台", shortName: "防空平台" },
            c1: { id: "c1", isBase: false, name: "附加载机机库", shortName: "大型载机" },
            c2: { id: "c2", isBase: false, name: "附加护航挺舱坞", shortName: "火控辅助" },
            c3: { id: "c3", isBase: false, name: "支援维修无人机系统", shortName: "维修飞机" },
        },
    },
    {
        id: "cr4",
        name: "FSV830",
        type: ShipTypes.carrier,
        pop: 40,
        limit: 2,
        modules: {
            a1: { id: "a1", isBase: false, name: "工程维修系统", shortName: "工程维修" },
            a2: { id: "a2", isBase: false, name: "战略资源存储系统", shortName: "战略存储" },
            b1: { id: "b1", isBase: true, name: "护卫舰生产系统", shortName: "护卫生产" },
            b2: { id: "b2", isBase: false, name: "护航艇生产系统", shortName: "炮艇生产" },
            b3: { id: "b3", isBase: false, name: "战机胜场系统", shortName: "战机生产" },
            c1: { id: "c1", isBase: false, name: "舰载机系统", shortName: "载机平台" },
            c2: { id: "c2", isBase: false, name: "维修无人机系统", shortName: "维修飞机" },
            d1: { id: "d1", isBase: true, name: "预警指挥系统", shortName: "预警指挥" },
            d2: { id: "d2", isBase: false, name: "协同指挥系统", shortName: "协同指挥" },
            d3: { id: "d3", isBase: false, name: "干扰指挥系统", shortName: "干扰指挥" },
            e1: { id: "e1", isBase: false, name: "区域防空系统", shortName: "区域防空" },
            e2: { id: "e2", isBase: false, name: "护航艇坞仓", shortName: "护航艇仓" },
        },
    },
    {
        id: "cr5",
        name: "埃迪卡拉级",
        type: ShipTypes.carrier,
        pop: 40,
        limit: 2,
        modules: {
            m1: { id: "m1", isBase: true, name: "堡垒坚守重炮体统", shortName: "堡垒重炮" },
            m2: { id: "m2", isBase: false, name: "堡垒攻坚轨道炮系统", shortName: "堡垒轨道" },
            b1: { id: "b1", isBase: true, name: "护卫舰生产系统", shortName: "护卫生产" },
            b2: { id: "b2", isBase: false, name: "护航艇生产系统", shortName: "炮艇生产" },
            b3: { id: "b3", isBase: false, name: "驱逐舰生产系统", shortName: "驱逐生产" },
            c1: { id: "c1", isBase: false, name: "大型载机系统", shortName: "大型载机" },
            c2: { id: "c2", isBase: false, name: "护航艇坞仓", shortName: "炮艇船坞" },
            d1: { id: "d1", isBase: true, name: "苔原拦截无人机系统", shortName: "苔原拦截" },
            d2: { id: "d2", isBase: false, name: "蜂鸟火力侦察系统", shortName: "蜂鸟侦查" },
            d3: { id: "d3", isBase: false, name: "巨像护卫无人机系统", shortName: "巨像护卫" },
            e1: { id: "e1", isBase: false, name: "重型附加装甲系统", shortName: "重型装甲" },
            e2: { id: "e2", isBase: false, name: "纳米级自维修系统", shortName: "纳米维修" },
        },
    },
];

const BATTLE_CRUISER_DATA: SuperCapData[] = [
    {
        id: "bc1",
        name: "新君士大帝级",
        type: ShipTypes.battleCruiser,
        pop: 35,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "伽马风暴粒子攻击系统", shortName: "离子攻击" },
            m2: { id: "m2", isBase: false, name: "伽马风暴粒子投射系统", shortName: "离子投射" },
            a1: { id: "a1", isBase: true, name: "伽马风暴投射攻击系统", shortName: "投射攻击" },
            a2: { id: "a2", isBase: false, name: "伽马风暴投射攻击系统", shortName: "投射攻击" },
            b1: { id: "b1", isBase: false, name: "通用火炮模块", shortName: "通用火炮" },
            b2: { id: "b2", isBase: false, name: "脉冲防空系统", shortName: "脉冲防空" },
            b3: { id: "b3", isBase: false, name: "防空导弹系统", shortName: "防空导弹" },
            c1: { id: "c1", isBase: false, name: "附加能源系统", shortName: "能源系统" },
            c2: { id: "c2", isBase: false, name: "舰载机系统", shortName: "舰载机仓" },
            c3: { id: "c3", isBase: false, name: "侦察无人机系统", shortName: "侦察机仓" },
            d1: { id: "d1", isBase: false, name: "近程防空系统", shortName: "防空系统" },
            d2: { id: "d2", isBase: false, name: "重点防护模块", shortName: "防护模块" },
            d3: { id: "d3", isBase: false, name: "损管系统", shortName: "损管系统" },
        },
    },
    {
        id: "bc7",
        name: "安东塔斯持剑者级",
        type: ShipTypes.battleCruiser,
        pop: 35,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "蜂群无人机作战中枢", shortName: "蜂群中枢" },
            m2: { id: "m2", isBase: false, name: "联合无人机作战中枢", shortName: "联合中枢" },
            m3: { id: "m3", isBase: false, name: "同频无人机作战中枢", shortName: "同频中枢" },
            a1: { id: "a1", isBase: true, name: "利剑指挥系统", shortName: "利剑指挥" },
            a2: { id: "a2", isBase: false, name: "短剑指挥系统", shortName: "短剑指挥" },
            a3: { id: "a3", isBase: false, name: "阔剑指挥系统", shortName: "阔剑指挥" },
            b1: { id: "b1", isBase: false, name: "护航艇搭载系统", shortName: "护航艇仓" },
            b2: { id: "b2", isBase: false, name: "导弹发射系统", shortName: "导弹发射" },
            b3: { id: "b3", isBase: false, name: "脉冲炮系统", shortName: "脉冲炮塔" },
            c1: { id: "c1", isBase: false, name: "强化装甲系统", shortName: "强化装甲" },
            c2: { id: "c2", isBase: false, name: "电磁能量装甲", shortName: "电磁装甲" },
            c3: { id: "c3", isBase: false, name: "附加装甲系统", shortName: "附加装甲" },
            d1: { id: "d1", isBase: false, name: "防空导弹系统", shortName: "防空导弹" },
            d2: { id: "d2", isBase: false, name: "矿车投射矩阵系统", shortName: "矿车投射" },
            d3: { id: "d3", isBase: false, name: "导弹投射系统", shortName: "导弹投射" },
        },
    },
    {
        id: "bc2",
        name: "乌拉诺斯之矛",
        type: ShipTypes.battleCruiser,
        pop: 35,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "舰首轨道炮系统", shortName: "重轨道炮" },
            m2: { id: "m2", isBase: false, name: "离子炮塔系统", shortName: "离子炮塔" },
            a1: { id: "a1", isBase: true, name: "堡垒火炮系统", shortName: "堡垒火炮" },
            a2: { id: "a2", isBase: false, name: "堡垒火炮系统", shortName: "堡垒火炮" },
            a3: { id: "a3", isBase: false, name: "堡垒火炮系统", shortName: "堡垒火炮" },
            b1: { id: "b1", isBase: false, name: "矿车投射系统", shortName: "矿车投射" },
            b2: { id: "b2", isBase: false, name: "护航艇船舱", shortName: "护航艇仓" },
            b3: { id: "b3", isBase: false, name: "总和损管系统", shortName: "损管系统" },
            c1: { id: "c1", isBase: false, name: "分布式轻型武器控制系统", shortName: "防空系统" },
            c2: { id: "c2", isBase: false, name: "附加装甲系统", shortName: "附加装甲" },
            c3: { id: "c3", isBase: false, name: "反导拦截系统", shortName: "拦截系统" },
        },
    },
    {
        id: "bc6",
        name: "普鲁图斯之盾",
        type: ShipTypes.battleCruiser,
        pop: 35,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "综合武器系统", shortName: "综合武器" },
            m2: { id: "m2", isBase: false, name: "综合火炮系统", shortName: "综合火炮" },
            m3: { id: "m3", isBase: false, name: "矿车投射矩阵系统", shortName: "矿车投射" },
            a1: { id: "a1", isBase: true, name: "堡垒护卫系统", shortName: "堡垒护卫" },
            a2: { id: "a2", isBase: false, name: "堡垒区域火控系统A型", shortName: "火控A型" },
            a3: { id: "a3", isBase: false, name: "堡垒区域火控系统B型", shortName: "火控B型" },
            b1: { id: "b1", isBase: false, name: "综合维修系统", shortName: "综合维修" },
            b2: { id: "b2", isBase: false, name: "附加装甲系统", shortName: "附加装甲" },
            b3: { id: "b3", isBase: false, name: "反导拦截系统", shortName: "反导拦截" },
            c1: { id: "c1", isBase: false, name: "武器多目标反击系统", shortName: "多重反击" },
            c2: { id: "c2", isBase: false, name: "防空拦截系统", shortName: "防空拦截" },
            c3: { id: "c3", isBase: false, name: "重型投射武器系统", shortName: "重型投射" },
        },
    },
    {
        id: "bc3",
        name: "永恒风暴",
        type: ShipTypes.battleCruiser,
        pop: 32,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "雷式离子生成系统", shortName: "高离子炮" },
            m2: { id: "m2", isBase: false, name: "离子炮塔系统", shortName: "离子炮塔" },
            a1: { id: "a1", isBase: true, name: "永远的北极星MARKII", shortName: "对舰鱼雷" },
            a2: { id: "a2", isBase: false, name: "永远的北极星MARKII", shortName: "攻城鱼雷" },
            a3: { id: "a3", isBase: false, name: "永远的北极星MARKII", shortName: "防空鱼雷" },
            b1: { id: "b1", isBase: false, name: "通用火炮模块", shortName: "通用火炮" },
            b2: { id: "b2", isBase: false, name: "通用近防系统", shortName: "通用近防" },
            c1: { id: "c1", isBase: false, name: "NT无人机防空系统", shortName: "防空飞机" },
            c2: { id: "c2", isBase: false, name: "雷暴无人机护盾", shortName: "护盾飞机" },
            c3: { id: "c3", isBase: false, name: "能量补偿装甲", shortName: "能量装甲" },
            d1: { id: "d1", isBase: false, name: "离子炮打系统", shortName: "离子炮塔" },
            d2: { id: "d2", isBase: false, name: "脉冲炮打系统", shortName: "脉冲炮塔" },
        },
    },
    {
        id: "bc4",
        name: "ST59",
        type: ShipTypes.battleCruiser,
        pop: 28,
        limit: 6,
        modules: {
            m1: { id: "m1", isBase: true, name: "攻坚轨道炮系统", shortName: "重轨道炮" },
            m2: { id: "m2", isBase: false, name: "舰首火炮系统", shortName: "舰首火炮" },
            m3: { id: "m3", isBase: false, name: "攻坚鱼雷系统", shortName: "攻坚鱼雷" },
            a1: { id: "a1", isBase: true, name: "大型火炮平台", shortName: "火炮平台" },
            a2: { id: "a2", isBase: false, name: "轨道炮塔阵列", shortName: "轨道炮塔" },
            a3: { id: "a3", isBase: false, name: "脉冲炮塔阵列", shortName: "脉冲炮塔" },
            b1: { id: "b1", isBase: false, name: "综合投射武器平台", shortName: "投射平台" },
            b2: { id: "b2", isBase: false, name: "舰载机系统", shortName: "舰载机仓" },
            b3: { id: "b3", isBase: false, name: "区域火控系统", shortName: "区域火控" },
            c1: { id: "c1", isBase: false, name: "附加装甲系统", shortName: "附加装甲" },
            c2: { id: "c2", isBase: false, name: "电磁装甲系统", shortName: "电磁装甲" },
            c3: { id: "c3", isBase: false, name: "重型防卫装甲", shortName: "重型装甲" },
        },
    },
    {
        id: "bc5",
        name: "雷火之星",
        type: ShipTypes.battleCruiser,
        pop: 35,
        limit: 3,
        modules: {
            m1: { id: "m1", isBase: true, name: "舰首武器系统", shortName: "舰首轨道" },
            m2: { id: "m2", isBase: false, name: "舰首投射武器系统", shortName: "投射鱼雷" },
            m3: { id: "m3", isBase: false, name: "舰首高能武器系统", shortName: "离子火炮" },
            a1: { id: "a1", isBase: true, name: "快速反舰武器系统", shortName: "快速反舰" },
            a2: { id: "a2", isBase: false, name: "中型反舰武器系统", shortName: "中型反舰" },
            b1: { id: "b1", isBase: true, name: "主动防空系统", shortName: "防空导弹" },
            b2: { id: "b2", isBase: false, name: "范围拦截系统", shortName: "范围拦截", important: true },
            c1: { id: "c1", isBase: false, name: "武器协同运作中枢", shortName: "武器协同", important: true },
            c2: { id: "c2", isBase: false, name: "火控校准系统", shortName: "火控校准" },
            e1: { id: "e1", isBase: false, name: "精准投射武器系统", shortName: "投射导弹" },
            e2: { id: "e2", isBase: false, name: "大型投射武器系统", shortName: "投射鱼雷" },
            f1: { id: "f1", isBase: false, name: "多目标武器系统", shortName: "舰队反击" },
            f2: { id: "f2", isBase: false, name: "多目标防空系统", shortName: "防空反击" },
        },
    },
];

const CRUISER_DATA: ShipData[] = [
    {
        id: "c2",
        name: "艾奥级",
        type: ShipTypes.cruiser,
        pop: [18, 18, 18],
        limit: 8,
        variants: ["离子炮", "反舰型", "攻城型"],
    },
    {
        id: "c3",
        name: "奇美拉級",
        type: ShipTypes.cruiser,
        pop: [18, 20, 20],
        limit: 8,
        variants: ["炮弹型", "重炮型", "防衛型"],
    },
    {
        id: "c1",
        name: "卡利斯托級",
        type: ShipTypes.cruiser,
        pop: [20, 20, 20],
        limit: 8,
        variants: ["鱼雷型", "反舰型", "支援型"],
    },
    { id: "c4", name: "猎兵级", type: ShipTypes.cruiser, pop: [20, 18], limit: 8, variants: ["支援型", "反舰型"] },
    { id: "c6", name: "康納混沌级", type: ShipTypes.cruiser, pop: [20, 20], limit: 8, variants: ["轨道炮", "电浆型"] },
    {
        id: "c7",
        name: "光锥级",
        type: ShipTypes.cruiser,
        pop: [20, 20, 20],
        limit: 8,
        variants: ["通用型", "防空型", "突击型"],
    },
    {
        id: "c5",
        name: "狩猎者级",
        type: ShipTypes.cruiser,
        pop: [18, 18, 18],
        limit: 8,
        variants: ["通用型", "战术型", "防空型"],
    },
    {
        id: "c8",
        name: "CAS066級",
        type: ShipTypes.cruiser,
        pop: [18, 18, 18, 18],
        limit: 12,
        variants: ["綜合型", "炮击型", "载机型", "支援型"],
    },
    {
        id: "c9",
        name: "KCCPV2.0",
        type: ShipTypes.cruiser,
        pop: [16, 16, 16],
        limit: 12,
        variants: ["綜合型", "载机型", "轨道炮", "脉冲型"],
    },
    { id: "c10", name: "游骑兵级", type: ShipTypes.cruiser, pop: [18, 18], limit: 8, variants: ["综合型", "离子炮"] },
];

const FRIGATE_DATA: ShipData[] = [
    {
        id: "d1",
        name: "刺水母级",
        type: ShipTypes.frigate,
        pop: [8, 6],
        limit: 10,
        variants: ["特种型", "防空型", "登陆型"],
    },
    {
        id: "d12",
        name: "锆石级",
        type: ShipTypes.frigate,
        pop: [8, 8],
        limit: 10,
        variants: ["突击型", "特种型"],
    },
    {
        id: "d2",
        name: "雷里亚特级",
        type: ShipTypes.frigate,
        pop: [4, 4, 4],
        limit: 10,
        variants: ["反舰型", "魚雷型", "隐身型"],
    },
    {
        id: "d3",
        name: "红宝石级",
        type: ShipTypes.frigate,
        pop: [5, 8, 5],
        limit: 10,
        variants: ["轨道炮", "粒子炮", "防卫型"],
    },
    { id: "d10", name: "雨海级", type: ShipTypes.frigate, pop: [5, 8], limit: 10, variants: ["轨道炮", "脉冲型"] },
    {
        id: "d4",
        name: "卡里莱恩级",
        type: ShipTypes.frigate,
        pop: [4, 5, 5],
        limit: 10,
        variants: ["侦查型", "重炮型", "特種型"],
    },
    {
        id: "d5",
        name: "澄海級",
        type: ShipTypes.frigate,
        pop: [5, 5, 5],
        limit: 10,
        variants: ["反舰型", "飞弹型", "防空型"],
    },
    {
        id: "d6",
        name: "诺玛級",
        type: ShipTypes.frigate,
        pop: [6, 6, 6],
        limit: 10,
        variants: ["攻城型", "支援型", "防空型"],
    },
    {
        id: "d7",
        name: "静海级",
        type: ShipTypes.frigate,
        pop: [4, 4, 4],
        limit: 10,
        variants: ["综合型", "脉冲型", "防空型"],
    },
    { id: "d8", name: "云海级", type: ShipTypes.frigate, pop: [4, 4], limit: 10, variants: ["突擊型", "防空型"] },
    {
        id: "d11",
        name: "狼蜥级",
        type: ShipTypes.frigate,
        pop: [6, 6, 8],
        limit: 10,
        variants: ["防御型", "突击型", "特种型"],
    },
    {
        id: "d9",
        name: "FG300级",
        type: ShipTypes.frigate,
        pop: [3, 3, 3],
        limit: 15,
        variants: ["多功能", "装甲型", "侦察型"],
    },
];

const DESTROYER_DATA: ShipData[] = [
    {
        id: "f2",
        name: "斗牛级",
        type: ShipTypes.destroyer,
        pop: [11, 11, 8],
        limit: 10,
        variants: ["攻击型", "突击型", "防御型"],
    },
    {
        id: "f5",
        name: "阋神星级",
        type: ShipTypes.destroyer,
        pop: [7, 9, 7],
        limit: 10,
        variants: ["火炮型", "重炮型", "裝甲型"],
    },
    {
        id: "f9",
        name: "亚达伯拉级",
        type: ShipTypes.destroyer,
        pop: [8, 8],
        limit: 10,
        variants: ["通用型", "裝甲型", "防空型"],
    },
    { id: "f6", name: "创神星级", type: ShipTypes.destroyer, pop: [6, 6], limit: 10, variants: ["轨道炮", "魚雷型"] },
    {
        id: "f7",
        name: "枪骑兵级",
        type: ShipTypes.destroyer,
        pop: [6, 6, 6],
        limit: 10,
        variants: ["反舰型", "綜合型", "防空型"],
    },
    {
        id: "f8",
        name: "卫士级",
        type: ShipTypes.destroyer,
        pop: [9, 14, 9],
        limit: 10,
        variants: ["支援型", "两栖型", "脉冲炮"],
    },
    { id: "f1", name: "苔原级", type: ShipTypes.destroyer, pop: [9, 9], limit: 10, variants: ["支援型", "载机型"] },
    {
        id: "f3",
        name: "谷神星级",
        type: ShipTypes.destroyer,
        pop: [8, 8, 8],
        limit: 10,
        variants: ["载机型", "支援型", "战术型"],
    },
    {
        id: "f4",
        name: "AC721級",
        type: ShipTypes.destroyer,
        pop: [8, 12, 8],
        limit: 15,
        variants: ["通用型", "载机型", "飞弹型"],
    },
];

const AIRCRAFT_DATA: AircraftData[] = [
    { id: "a1", name: "密斯托拉", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a12", name: "雷火V022", type: ShipTypes.aircraft, variants: ["防空型", "特种型", "干扰型"], limit: 8 },
    { id: "a2", name: "海氏追隨者", type: ShipTypes.aircraft, variants: [""], limit: 8 },
    { id: "a3", name: "林鴞A100", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a4", name: "砂龙", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a5", name: "維塔斯 A021", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a7", name: "孢子A404", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a8", name: "新大地B192", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a9", name: "佩刀Aer410", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a6", name: "平衡安德森", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a10", name: "SC002", type: ShipTypes.aircraft, variants: [""], limit: 10 },
    { id: "a11", name: "AT021", type: ShipTypes.aircraft, variants: ["脉冲型", "干扰型", "多功能"], limit: 15 },
];

const BOMBER_DATA: AircraftData[] = [
    { id: "b1", name: "維塔斯 B010", type: ShipTypes.bomber, variants: [""], limit: 10 },
    { id: "b2", name: "刺鰩", type: ShipTypes.bomber, variants: [""], limit: 10 },
    { id: "b3", name: "牛蛙", type: ShipTypes.bomber, variants: [""], limit: 10 },
    { id: "b4", name: "BR050", type: ShipTypes.bomber, variants: ["反舰型", "多用途", "鱼雷型"], limit: 10 },
];

const CORVETTE_DATA: AircraftData[] = [
    { id: "e1", name: "星云追逐者", type: ShipTypes.corvette, limit: 10, variants: ["弹炮型", "脉冲型"] },
    { id: "e2", name: "CV-T800", type: ShipTypes.corvette, limit: 15, variants: [""] },
    { id: "e3", name: "蜂巢守卫者", type: ShipTypes.corvette, limit: 10, variants: [""] },
    { id: "e4", name: "S-列维9号", type: ShipTypes.corvette, limit: 10, variants: [""] },
    { id: "e5", name: "虚灵", type: ShipTypes.corvette, limit: 10, variants: [""] },
    { id: "e10", name: "海尔波普", type: ShipTypes.corvette, limit: 10, variants: ["多功能", "对接型"] },
    { id: "e11", name: "坦普尔1号", type: ShipTypes.corvette, limit: 10, variants: ["干扰型", "预警型"] },
    { id: "e6", name: "RB7-13", type: ShipTypes.corvette, limit: 10, variants: ["攻击型", "突防型"] },
    { id: "e7", name: "鳐", type: ShipTypes.corvette, limit: 10, variants: ["高速型", "防御型"] },
    {
        id: "e8",
        name: "CV-M011",
        type: ShipTypes.corvette,
        limit: 15,
        variants: ["导弹型", "火炮型", "高速型"],
    },
    { id: "e9", name: "CV-II003", type: ShipTypes.corvette, limit: 10, variants: [""] },
];

export const UNIT_DATA_BASE: UnitDataBase = {
    carriers: { label: "航空母舰", type: ShipTypes.carrier, list: CARRIER_DATA },
    battleCruisers: { label: "战斗巡洋舰", type: ShipTypes.battleCruiser, list: BATTLE_CRUISER_DATA },
    cruisers: { label: "巡洋舰", type: ShipTypes.cruiser, list: CRUISER_DATA },
    destroyers: { label: "驱逐舰", type: ShipTypes.destroyer, list: DESTROYER_DATA },
    frigates: { label: "护卫舰", type: ShipTypes.frigate, list: FRIGATE_DATA },
    aircrafts: { label: "战机", type: ShipTypes.aircraft, list: AIRCRAFT_DATA },
    bombers: { label: "轰炸机", type: ShipTypes.bomber, list: BOMBER_DATA },
    corvettes: { label: "护航艇", type: ShipTypes.corvette, list: CORVETTE_DATA },
};

let ShipLookupTable: { [index: string]: UnitData };

export function lookUpShipById(index: string): UnitData | undefined {
    if (ShipLookupTable === null || ShipLookupTable === undefined) {
        ShipLookupTable = {};
        Object.values(UNIT_DATA_BASE).forEach((shipType: UnitDataGroup) => {
            shipType.list.forEach((ship) => {
                ShipLookupTable[ship.id] = ship;
            });
        });
    }
    return ShipLookupTable[index];
}
